import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '¿Qué necesito para calificar al Funding?',
      answer: 'Para calificar al servicio de Funding necesitas tener un perfil crediticio sólido que incluya: un score de crédito mínimo (generalmente 680+), historial crediticio establecido, bajo nivel de utilización de crédito, y capacidad de pago demostrable. Si tu perfil aún no cumple estos requisitos, podemos ayudarte primero con nuestro servicio de reestructuración de crédito.'
    },
    {
      question: '¿En cuánto tiempo puedo ver resultados?',
      answer: 'Los tiempos varían según tu perfil inicial, pero típicamente nuestros clientes comienzan a ver aprobaciones en las primeras 4-8 semanas. El proceso completo de obtención de capital puede tomar entre 2-3 meses, dependiendo de la estrategia diseñada para tu caso específico y los montos objetivo.'
    },
    {
      question: '¿Es un préstamo de Cashflow VIP?',
      answer: 'No. Cashflow VIP no otorga préstamos propios. Nuestro servicio de Funding es una consultoría estratégica donde te ayudamos a conseguir tarjetas de crédito personales y de negocio, líneas de crédito y productos bancarios directamente con instituciones financieras. Nosotros te guiamos en el proceso, optimizamos tu perfil y ejecutamos las aplicaciones estratégicamente.'
    },
    {
      question: '¿El 0% de interés es para siempre?',
      answer: 'No. El 0% APR es un período promocional que ofrecen las instituciones financieras, típicamente entre 12-21 meses dependiendo del producto. Después de este período, se aplica la tasa regular de la tarjeta. Parte de nuestra estrategia incluye enseñarte cómo maximizar este período promocional y planificar el uso del capital de forma inteligente.'
    },
    {
      question: '¿Qué pasa si mi crédito no está listo para Funding?',
      answer: 'Si después de evaluar tu perfil determinamos que aún no cumples con los requisitos mínimos para el Funding, no te preocupes. Tenemos un servicio especializado de reestructuración de crédito que te ayudará a preparar tu perfil crediticio. Una vez que alcances los estándares necesarios, podrás acceder al servicio de Funding. Es un proceso paso a paso diseñado para tu éxito a largo plazo.'
    }
  ];

  return (
    <section className="py-24 bg-[#1C1C1C] relative">
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/50 to-transparent"></div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Preguntas <span className="text-[#D4AF37]">Frecuentes</span>
          </h2>
          <p className="text-xl text-gray-400">
            Resolvemos tus dudas sobre el servicio de Funding
          </p>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto mt-6"></div>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-[#050505]/50 rounded-xl border border-[#D4AF37]/20 overflow-hidden transition-all duration-300 hover:border-[#D4AF37]/60"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer group"
              >
                <span className="text-lg font-semibold text-white pr-4 group-hover:text-[#D4AF37] transition-colors duration-300">
                  {faq.question}
                </span>
                <div className={`w-8 h-8 bg-[#D4AF37]/10 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${openIndex === index ? 'bg-[#D4AF37]' : ''}`}>
                  <i className={`ri-arrow-down-s-line text-xl transition-all duration-300 ${openIndex === index ? 'rotate-180 text-[#050505]' : 'text-[#D4AF37]'}`}></i>
                </div>
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6">
                  <p className="text-gray-300 leading-relaxed">
                    {faq.answer}
                  </p>
                  
                  {/* Enlace especial para la última pregunta */}
                  {index === faqs.length - 1 && (
                    <div className="mt-6 p-4 bg-[#D4AF37]/10 rounded-lg border-l-4 border-[#D4AF37]">
                      <p className="text-white font-semibold mb-2">
                        <i className="ri-links-line text-[#D4AF37] mr-2"></i>
                        ¿Necesitas reestructurar tu crédito primero?
                      </p>
                      <a
                        href="https://credit.cashflow.vip/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 text-[#D4AF37] font-semibold hover:text-[#F4D03F] transition-colors duration-300 cursor-pointer"
                      >
                        Conoce nuestro servicio de crédito aquí
                        <i className="ri-external-link-line"></i>
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA adicional */}
        <div className="mt-12 text-center">
          <p className="text-gray-400 mb-4">¿Tienes más preguntas?</p>
          <button
            onClick={() => window.open('https://wa.me/13056840894', '_blank')}
            className="inline-flex items-center gap-2 px-6 py-3 bg-transparent border-2 border-[#D4AF37] text-[#D4AF37] font-semibold rounded-lg hover:bg-[#D4AF37] hover:text-[#050505] transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Contáctanos por WhatsApp
          </button>
        </div>
      </div>
    </section>
  );
}
